import React, { useContext } from "react";
import {Navigate, useNavigate} from "react-router-dom";
import { AuthContext } from "../AuthContext";
import Styles from "../styles/pages/Dashboard.module.css";
import NewServiceForm from "../components/NewServiceForm";
import {isUserInRole} from "../pr_utils";

const Dashboard = (props) => {
    const { authStatus } = useContext(AuthContext);
    const userRole = props.user_info?.role;
    const navigate = useNavigate();

    // Block unauthenticated users or non-admins
    if (!authStatus || !isUserInRole(authStatus, ['ADMIN', 'DIRECTORY_VIEWER', 'DIRECTORY_EDITOR', 'SERVICE_EDITOR', 'SERVICE_VIEWER'])) {
        return <Navigate to="/" />;
    }

    return (
        <div className={Styles.dashboardContainer}>
            <h1>Admin Dashboard</h1>
            <p>Welcome!</p>

            {/* Add admin components or panels below */}
            <div className={Styles.panelGroup}>
                <div className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR', 'SERVICE_VIEWER']) ? Styles.panelCard : Styles.hidden}>
                    <button
                        onClick={() => navigate('/service_planner')}
                        className={Styles.button}
                    >
                        Service Planner
                    </button>
                </div>
                <div className={isUserInRole(authStatus, ['ADMIN']) ? Styles.panelCard : Styles.hidden}>
                    <button
                        onClick={() => navigate('/user_management')}
                        className={Styles.button}
                    >
                        Manage Users
                    </button>
                </div>
                <div className={isUserInRole(authStatus, ['ADMIN']) ? Styles.panelCard : Styles.hidden}>Reports (coming soon)</div>
            </div>
            <div className={Styles.panelGroup}>
                <div className={isUserInRole(authStatus, ['ADMIN', 'DIRECTORY_EDITOR', 'DIRECTORY_VIEWER']) ? Styles.panelCard : Styles.hidden}>
                    <button
                        onClick={() => navigate('/directory')}
                        className={Styles.button}
                    >
                        Church Directory
                    </button>
                </div>

                <div className={isUserInRole(authStatus, ['ADMIN']) ? Styles.panelCard : Styles.hidden}>
                    <button
                        onClick={() => navigate('/audio_edit')}
                        className={Styles.button}
                    >
                        Audio Trimmer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
